import {useEffect} from 'react';
import {request} from '../../../services/HttpRequestService';
import {storageService} from '../../../services/storageService';
import {AutoProjectStatusTabs} from '../../AutoProjectStatusTabs/Config/AutoProjectStatusTabs.config';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useAutoProjectTrainingStatus = ({ projectIdInit, value = -1, setTrainings = (newTrain: {}) => {}, setState}) => {

    /***
     * fetchTrainingData - fetching training history data from server
     * @param projectIdInit - the id of the data project
     */
    const fetchTrainingData = async (projectIdInit) => {
        const res = await request.get(storageService.loadFromStorage('token'), 'GET_HISTORY_TRAINING', false, projectIdInit);


        return res.data;
    };


    /***
     * initTrainingsData - calling to fetch training history data from server, updates trainings
     * local state and returns the new trainings state for global use
     * @param projectIdInit - the id of the data project
     */
    const initTrainingsData = async (projectIdInit) => {
        try {
            const trainingData = await fetchTrainingData(projectIdInit);
            const newState = {};

            for (const curTrain of trainingData as any) {
                const featureName = curTrain['feature_name'];

                newState[featureName] ? newState[featureName] = [...JSON.parse(JSON.stringify(newState[featureName])), curTrain] : newState[featureName] = [curTrain];
            }

            setTrainings({...newState});

            return newState;

        } catch (e) {
            console.log(e);
        }

    };

    useEffect(() => {
        if (value === AutoProjectStatusTabs.TrainingStatus) {
            initTrainingsData(projectIdInit);
        }
    }, [value]);

    return {initTrainingsData};
};


export default useAutoProjectTrainingStatus;
